import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
  trackAdmissionsAdvisorRouteScreenView,
  trackCrmRouteScreenView,
  trackEstimateRouteScreenView,
  trackHubRouteScreenView,
  trackMobileRouteScreenView,
  trackPatientsRouteScreenView,
  trackSpecialistRouteScreenView,
} from './google-analytics';

/**
 * Central route analytics for finpass-ui. Dispatches screen_view events for
 * mapped route prefixes (/patients, /hub, /mobile, /specialist, etc.) on SPA navigation.
 */
export function RouteAnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    trackPatientsRouteScreenView(location.pathname);
    trackHubRouteScreenView(location.pathname);
    trackMobileRouteScreenView(location.pathname);
    trackSpecialistRouteScreenView(location.pathname);
    trackEstimateRouteScreenView(location.pathname);
    trackAdmissionsAdvisorRouteScreenView(location.pathname);
    trackCrmRouteScreenView(location.pathname);
  }, [location.pathname]);

  return null;
}

/** @deprecated Use RouteAnalyticsListener */
export const HubRouteAnalyticsListener = RouteAnalyticsListener;
